import { ERROR_REMOVE_PI_NOT_FOUND } from '../constants/errors';
import { paramDsName } from '../constants/parameterNames';
import { typeDataSource } from '../constants/parameterTypes';
import { failure, success } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';
import { removePi } from '../helpers/qRules.node.helpers';
import { DBXL_PI_NAME } from '../helpers/qRules.processingInstruction.helpers';

const description = "Removes the DBXL Processing Instructions from an xml document. This command takes no parameters.";

const optionalParameters = {
    [paramDsName]: {
        description: 'Data source name.',
        type: typeDataSource,
    },
};

function execute({ dataSources, parameters }) {
    const dsName = getParamValue(parameters, paramDsName);

    return removePi(dataSources, DBXL_PI_NAME, dsName)
        ? success()
        : failure(ERROR_REMOVE_PI_NOT_FOUND);
}

const RemoveDbxlPi = {
    description,
    execute,
    optionalParameters,
};

export default RemoveDbxlPi;